import { getLocales } from 'assets/locales/Locale';
import { date, defaultDateTimeFormat, defaultServerDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import contractRefundCommentDeleteApi from './delete/Api.ContractRefundComment.Delete';
import contractRefundCommentListApi from './list/Api.ContractRefundComment.List';
import contractRefundCommentSaveApi from './save/Api.ContractRefundComment.Save';

export default class ContractRefundComment
  extends Model<Model.IContractRefundComment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractRefundComment>
{
  id: number;
  comment: string;
  createdAtUtc: string;
  modifiedAtUtc: string;
  userId: number;
  user: User;
  contractRefundId: number;

  get createdAtUtcUnix() {
    return date(this.createdAtUtc, defaultServerDateTimeFormat).unix();
  }
  get modifiedAtUtcUnix() {
    return this.modifiedAtUtc ? date(this.modifiedAtUtc, defaultServerDateTimeFormat).unix() : null;
  }

  constructor(
    data: Partial<Model.IContractRefundComment> | Utils.FormData<Model.IContractRefundComment>,
    language?: Locale.Languages
  ) {
    super(
      {
        user: User,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    const { lang } = getLocales();
    return {
      id: this.id,
      title: this.user?.displayInfo?.title || lang.unknownUser,
      info: localizeDate(this.createdAtUtc, defaultDateTimeFormat),
      subtitle: this.comment,
      media: this.user?.profilePhoto?.url,
    };
  }
  async save() {
    return await contractRefundCommentSaveApi(this);
  }
  async delete() {
    return await contractRefundCommentDeleteApi({ id: this.id });
  }

  static async list(body?: Api.Sales.ContractRefundComment.List.IRequest) {
    const { payload, ...rest } = await contractRefundCommentListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractRefundComment(it)),
        count: payload.count,
      },
    };
  }
}
